import { apiGet, apiPost } from "./client";

export interface GoogleCalendarStatus {
  connected: boolean;
  configured: boolean;
  connectedAt?: string;
  scopes?: string;
  hasGmailSend?: boolean;
  needsReconsent?: boolean;
}

export interface GoogleCalendarEvent {
  id: string;
  summary?: string;
  description?: string;
  htmlLink?: string;
  start?: { dateTime?: string; date?: string };
  end?: { dateTime?: string; date?: string };
  attendees?: Array<{ email?: string; displayName?: string }>;
}

export async function getGoogleCalendarStatus(): Promise<GoogleCalendarStatus> {
  return apiGet("/api/crm/calendar/google/status");
}

export async function startGoogleOAuth(): Promise<{
  url: string;
  configured?: boolean;
}> {
  return apiGet("/api/crm/calendar/google/oauth/start");
}

export async function disconnectGoogleCalendar(): Promise<{
  connected: boolean;
}> {
  return apiPost("/api/crm/calendar/google/disconnect");
}

export async function listGoogleCalendarEvents(params?: {
  opportunityId?: string;
  createEngagement?: boolean;
}): Promise<{
  events: GoogleCalendarEvent[];
  opportunityId?: string;
  matchedContactEmails?: string[];
}> {
  return apiGet("/api/crm/calendar/google/events", {
    ...(params?.opportunityId ? { opportunityId: params.opportunityId } : {}),
    ...(params?.createEngagement ? { createEngagement: "true" } : {}),
  });
}
